import { render, staticRenderFns } from "./DistributorForm.vue?vue&type=template&id=70a9854c&scoped=true&"
import script from "./DistributorForm.vue?vue&type=script&lang=js&"
export * from "./DistributorForm.vue?vue&type=script&lang=js&"
import style0 from "./DistributorForm.vue?vue&type=style&index=0&id=70a9854c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a9854c",
  null
  
)

export default component.exports